import type { OrgsList } from "../../types/defaultTypes";
import { apiClient } from "../clientApi";
import type { AxiosResponse } from "axios";

interface SurveyUserListElement {
  id: number;
  courseName: string;
  survey_status: string;
  created_at: string;
  send_at: string;
  sent_on: string;
  session_id: string;
}

interface SurveyList {
  surveys: SurveyUserListElement[];
}

export const getUserSurveyList = async () => {
  const { data } = await apiClient.get<SurveyList, AxiosResponse<SurveyList>>(`/user-surveys/list`);

  return data as SurveyList;
};
